import { useState, useCallback, useRef } from 'react';

const useSwipe = (onSwipe, onSwipeEnd, rest = {}) => {
  const x = useRef(0);
  const y = useRef(0);

  const onMouseDown = useCallback((event) => {
    if (event?.clientX) {
      x.current = event.clientX;
      y.current = event.clientY;
    }
    setEventHandlers({ onMouseMove, onMouseUp, onMouseLeave });
  });
  const onMouseMove = useCallback((event) => onSwipe({ deltaX: event.clientX - x.current, deltaY: event.clientY - y.current }, event));
  const onMouseUp = useCallback((event) => {
    onSwipeEnd({ deltaX: event.clientX - x.current, deltaY: event.clientY - y.current }, event);
    setEventHandlers({ onMouseDown });
  });
  const onMouseLeave = onMouseUp;

  const [eventHandlers, setEventHandlers] = useState({ onMouseDown });

  if (rest.dragDisabled) {
    return 0;
  }

  return eventHandlers;
};

export default useSwipe;
